import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["carrier"];

  filter() {
    const filters = {
      carrier: this.carrierTarget.value
    };

    this.stimulate("AgeFactorReflex#filter", filters);
  }
}
